



































import { defineComponent, computed } from '@nuxtjs/composition-api';
import { SfNotification, SfIcon } from '@storefront-ui/vue';
import { useUiNotification } from '~/composables';

export default defineComponent({
  name: 'NotificationBar',
  components: {
    SfNotification,
    SfIcon,
  },
  setup() {
    const { notifications: allNotifications } = useUiNotification();
    const notifications = computed(()=>allNotifications.value.filter(el=>!el.isCartNotification))
    const position = computed(()=>allNotifications.value.find(el=>el.position)?.position)
    return {
      position,
      notifications
    };
  },
});
